import React from 'react';
import { Typography, Box } from '@mui/material';

const FeedbackCard = ({ type, content, color }) => {
  if (!content) return null;
  
  return (
    <Box sx={{ 
      flex: { xs: '1 1 100%', md: '1 1 0' },
      minWidth: { xs: '100%', md: '250px' },
      borderRadius: '4px',
      border: '1px solid #e0e0e0',
      borderTop: `3px solid ${color}8A`,
      overflow: 'hidden',
      backgroundColor: '#fff',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
    }}>
      <Box sx={{ 
        p: 1,
        borderBottom: '1px solid #f0f0f0',
        color: 'rgba(0, 0, 0, 0.87)',
        backgroundColor: `${color}1A`,
        fontSize: '14px',
      }}>
        {type}
      </Box>
      <Box sx={{ 
        p: 2,
        backgroundColor: '#fff',
      }}>
        <Typography 
          variant="body2" 
          component="pre"
          sx={{ 
            whiteSpace: 'pre-wrap',
            fontFamily: 'inherit',
            m: 0
          }}
        >
          {content}
        </Typography>
      </Box>
    </Box>
  );
};

export default FeedbackCard; 